import Vue from 'vue';
import Router from 'vue-router';

import Login from './views/Login';
import NotFound from './views/NotFound';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/landing',
      name: 'landing',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'landing' */ './views/Landing.vue'),
    },
    {
      path: '/register',
      name: 'register',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'register' */ './views/Register.vue'),
    },
    {
      path: '/trip',
      name: 'trip',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'trip' */ './views/Trip.vue'),
    },
    {
      path: '/memory/:prefectureId',
      name: 'memories',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'trip' */ './views/Memories.vue'),
    },
    {
      path: '/memory/:prefectureId/:memoryId',
      name: 'memory',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'trip' */ './views/Memory.vue'),
    },
    {
      path: '/history',
      name: 'history',
      component: () =>
        import(/* webpackChunkName: 'history' */ './views/History.vue'),
    },
    {
      path: '/gallery',
      name: 'gallery',
      component: () =>
        import(/* webpackChunkName: 'gallery' */ './views/Gallery.vue'),
    },
    {
      path: '/partner/:t1?/:t2?/:t3?',
      name: 'partner',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'partner' */ './views/Partner.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'terms' */ './views/Terms.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'privacy' */ './views/PrivacyPolicy.vue'),
    },
    {
      path: '/inquiry',
      name: 'inquiry',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: 'inquiry' */ './views/Inquiry.vue'),
    },
    {
      path: '*',
      component: NotFound,
      name: 'notFound',
    },
  ],
});
